import { useNavigate } from "react-router";
import { GlobalRoutes } from "../Routes";
import { organizationSetupRoutes } from "../../Pages/OrganizationSetup/Routes";
import { onboardingRoutes } from "../../Pages/Onboarding/Routes";
import { serviceCreationRoutes } from "../../Pages/AiServiceCreation/Routes";

export const useNavigateTo = () => {
    const navigate = useNavigate();

    const navigateTo = {
        login: () => navigate(GlobalRoutes.LOGIN.path),
        signUp: () => navigate(GlobalRoutes.SIGNUP.path),
        signUpConfirmation: () => navigate(GlobalRoutes.SIGNUP_CONFIRM.path),
        forgotPassword: () => navigate(GlobalRoutes.FORGOT_PASSWORD.path),
        forgotPasswordConfirm: () => navigate(GlobalRoutes.FORGOT_PASSWORD_CONFIRM.path),
        resetPassword: () => navigate(GlobalRoutes.RESET_PASSWORD.path),
        faq: () => navigate(GlobalRoutes.FAQ.path),
        enroll: () => navigate(GlobalRoutes.ENROLL.path),
        overview: () => navigate(GlobalRoutes.OVERVIEW.path),

        onboarding: (additionalPath = onboardingRoutes.ACCEPT_SERVICE_AGREEMENT.path) => {
            navigate(GlobalRoutes.ONBOARDING.path + "/" + additionalPath);
        },

        organizationSetup: (
            { orgUuid },
            additionalPath = organizationSetupRoutes.ORGANIZATION_PROFILE.path,
            options
        ) =>
            navigate(
                GlobalRoutes.ORGANIZATION_SETUP.pathFn({ orgUuid }) + "/" + additionalPath,
                options
            ),

        organizationStatus: ({ orgUuid }, options) =>
            navigate(GlobalRoutes.ORGANIZATION_STATUS.pathFn({ orgUuid }), options),

        daemonInfo: ({ daemonId }, options) =>
            navigate(GlobalRoutes.DAEMON_INFO.pathFn({ daemonId }), options),

        aiServiceCreation: (
            { orgUuid, serviceUuid },
            additionalPath = serviceCreationRoutes.PROFILE.path,
            options
        ) =>
            navigate(
                GlobalRoutes.AI_SERVICE_CREATION.pathFn({ orgUuid, serviceUuid }) +
                    "/" +
                    additionalPath,
                options
            ),

        inviteMembers: ({ orgUuid }, options) =>
            navigate(GlobalRoutes.INVITE_MEMBERS.pathFn({ orgUuid }), options),

        /**
         * @param {Object} param0
         * @param {boolean | undefined} param0.afterServiceLaunch flag
         */
        services: ({ orgUuid, afterServiceLaunch }) =>
            navigate(
                GlobalRoutes.SERVICES.pathFn({ orgUuid }),
                afterServiceLaunch && { state: { afterServiceLaunch } }
            ),

        // Generic navigation with any route and params
        to: (route, params, options) => {
            if (typeof route === "string") {
                navigate(route, options);
            } else if (route.pathFn) {
                navigate(route.pathFn(params), options);
            } else {
                console.error("Invalid route for navigation", route);
            }
        },

        // Replace navigation (for redirects)
        replace: {
            daemonInfo: ({ daemonId }) =>
                navigate(GlobalRoutes.DAEMON_INFO.pathFn({ daemonId }), { replace: true }),
            // ... other replace methods
        },
    };

    return navigateTo;
};
